export const apiOrigin =
  (import.meta.env.VITE_API_URL as string | undefined) ??
  (import.meta.env.PROD ? 'https://api.pick-pro.com' : 'http://localhost:3000');
